import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("gf_currency") || "gc");
  const setCurrency = (c) => { localStorage.setItem("gf_currency", c); setCurrencyState(c); };
  const [store, setStore] = useState({ open: false, tab: "buy" });
  const [success, setSuccess] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("gf_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("gf_token")) refresh().finally(() => setReady(true));
    else setReady(true);
  }, [refresh]);

  const signIn = (token, u) => {
    localStorage.setItem("gf_token", token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem("gf_token");
    setUser(null);
  };
  const openStore = (tab = "buy") => setStore({ open: true, tab });
  const closeStore = () => setStore((s) => ({ ...s, open: false }));

  return (
    <Ctx.Provider value={{ user, setUser, ready, refresh, signIn, signOut, currency, setCurrency, store, openStore, closeStore, setStore, success, setSuccess }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
